























































































import { computed, defineComponent, ref } from '@vue/composition-api';

import WorkingLogsDisplay from '@/components/Driver/WorkingLogsDisplay.vue';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDriverProfile from '@/useDriverProfile';
import useAuth from '@/useAuth';

const VehicleWithDriverObject = defineComponent({
  components: { WorkingLogsDisplay },
  props: {
    vehicle: {
      default() {
        return {
          id: -1,
          license: '',
          licenseProvince: '',
          model: 'Tesla Modal X',
          color: 'WHITE',
          year: '2077',
          fuelType: 'ElECTRIC',
          mile: '0',
          maxWidth: '100',
          maxLength: '200',
          maxHeight: '60',
          minWeight: '7',
          maxWeight: '20',
          avatarUrl: '',
          driver: {
            id: -1, name: 'โปรดเลือกคนขับรถ', avatarUrl: '', lastSevenDay: [],
          },
          vehicleWeight: 0,
          legalWeight: 0,
        };
      },
    },
    carryWeight: { default: 0.00 },
    rounded: { default: true },
    driver: { default() { return { id: -1 }; } },
    showDNProperties: { default: true },
    showWeightProperty: { default: true },
    totalDelivery: { default: 0 },
    totalDeliveryFee: { default: 0 },
    deliveryManCount: { default: 0 },
    uniqueId: { default: '' },
    distance: { default() { return ''; } },
    deliveryAreaCode: { default() { return ''; } },
    totalPrice: {},
    legalMaxWeight: { default: 0 },
    packagesPrice: {},
  },
  setup(props: any, { emit }: any) {
    const { me } = useAuth();
    const { distanceTypeToColor, possibleDistanceType } = useDeliveryAreaCode();
    const { mapLastSevenDaysDeliveryNotes } = useDriverProfile();
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const weightStatus = ref('');
    const computedCarryWeight = computed(() => {
      // If There is no weight
      if (props.carryWeight <= 0) {
        weightStatus.value = '';
        return [{ data: 0, color: 'pink' }, { data: props.vehicle.maxWeight, color: 'light-gray' }];
      }
      // If Weight less than minimum
      if (props.carryWeight < props.vehicle.minWeight) {
        weightStatus.value = 'น้ำหนักต่ำกว่าเกณฑ์';
        return [
          { data: props.carryWeight, color: 'yellow' },
          { data: props.vehicle.minWeight - props.carryWeight, color: 'light-gray' },
          { data: props.vehicle.maxWeight - ((props.carryWeight) + (props.vehicle.minWeight - props.carryWeight)), color: 'light-gray' },
        ];
      }
      if (props.carryWeight === props.vehicle.minWeight) {
        weightStatus.value = 'น้ำหนักผ่านเกณฑ์';
        return [
          { data: props.carryWeight, color: 'green' },
          { data: props.vehicle.maxWeight - (props.carryWeight), color: 'light-gray' },
          { data: props.carryWeight - props.vehicle.legalWeight, color: 'light-gray' },
        ];
      }
      // If Weight greater than minimum & weight less than legal weight
      if (props.carryWeight > props.vehicle.minWeight && props.carryWeight > props.vehicle.legalWeight) {
        weightStatus.value = 'น้ำหนักผิดกฎหมาย';
        return [
          { data: props.carryWeight, color: 'red' },
          { data: props.carryWeight - props.vehicle.minWeight, color: 'red' },
          { data: props.vehicle.maxWeight - (props.carryWeight + props.vehicle.minWeight), color: 'light-gray' },
          { data: props.carryWeight - props.vehicle.legalWeight, color: 'red' },
        ];
      }

      // If Weight greater than minimum & weight greater than legal weight
      if (props.carryWeight > props.vehicle.minWeight && props.carryWeight > props.vehicle.legalWeight) {
        weightStatus.value = 'น้ำหนักผ่านเกณฑ์';
        return [
          { data: props.carryWeight, color: 'green' },
          { data: props.carryWeight - props.vehicle.minWeight, color: 'green' },
          { data: props.vehicle.maxWeight - (props.carryWeight + props.vehicle.minWeight), color: 'light-gray' },
          { data: props.vehicle.legalWeight - (props.carryWeight + (props.carryWeight - props.vehicle.minWeight) + props.vehicle.maxWeight - (props.carryWeight + props.vehicle.minWeight)), color: 'orange' },
        ];
      }
      weightStatus.value = '';
      return [
        { data: props.carryWeight, color: 'green' },
        { data: props.vehicle.maxWeight - props.carryWeight, color: 'light-gray' },
      ];
    });

    function changeDeliveryManCount($event: any) {
      emit('changeDeliveryManCount', parseInt($event.target.value, 10));
    }

    return {
      me,
      toCurrency,
      distanceTypeToColor,
      mapLastSevenDaysDeliveryNotes,

      computedCarryWeight,
      changeDeliveryManCount,
      weightStatus,
    };
  },
});

export default VehicleWithDriverObject;
